import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class ArticleSlide extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get image() {
    return get(this, '_image.value[0].url', '');
  }

  get title() {
    return get(this, '_title.value', '');
  }

  get url() {
    return get(this, '_url.value', '');
  }

  get id() {
    return get(this, 'system.id', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/ArticleSlide.model.js